import { render } from "./ak.vue?vue&type=template&id=743d8112&scoped=true"
const script = {}

import "./ak.vue?vue&type=style&index=0&id=743d8112&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743d8112"]])

export default __exports__